import type { UserMeResponse } from "@/container/admin/hooks/users/Queries/useFetchUserMe"
import type { UserMeAddress } from "@/container/admin/hooks/users/Queries/useFetchUserMeAddress"
import { canAccessCarteira } from "./fetchUserDataForRedirect"

export type AreaOficial = "generais" | "membros"

export const OFICIAIS_LOGIN_PATH = "/oficiais-login"

export const AREAS_OFICIAIS = {
  generais: {
    base: "/generais-login",
    dados: "/generais-login/perfil/dados",
    carteira: "/generais-login/perfil/carteira-general",
  },
  membros: {
    base: "/membros-login",
    dados: "/membros-login/perfil/dados",
    carteira: "/membros-login/perfil/carteira-membro",
  },
} as const satisfies Record<AreaOficial, { base: string; dados: string; carteira: string }>

const CARGOS_AREA_GENERAIS = ["general", "marechal"]

export function resolverAreaPorCargo(nomeCargo?: string | null): AreaOficial {
  const cargo = nomeCargo?.toLowerCase() ?? ""
  return CARGOS_AREA_GENERAIS.some((termo) => cargo.includes(termo)) ? "generais" : "membros"
}

export function resolverDestinoPosLogin(
  userMe: UserMeResponse | null,
  userAddress: UserMeAddress | null
): string {
  const area = AREAS_OFICIAIS[resolverAreaPorCargo(userMe?.cargo_oficial?.nome)]
  return canAccessCarteira(userMe, userAddress) ? area.carteira : area.dados
}
